import React, { useState } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template41: Consejos útiles para viajar (Tips)
// Basado en Tips.jsx de guia-tokio; todo el contenido viene de page (backend).
// Valores CSS en píxeles para evitar que MUI multiplique por 8.
const Template41 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [sticker1Error, setSticker1Error] = useState(false);
	const [sticker2Error, setSticker2Error] = useState(false);

	const getImageSrc = (id) => {
		if (page.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const headerText = page.texts?.[0]?.content;
	const introText = page.texts?.[1]?.content;
	const tips =
		Array.isArray(page.tips)
			? page.tips
			: Array.isArray(page.data?.tips)
			? page.data.tips
			: Array.isArray(page.data?.data?.tips)
			? page.data.data.tips
			: [];

	const pageOrder =
		page.order !== undefined
			? page.order
			: page.data?.order !== undefined
			? page.data.order
			: -1;
	const isTokioGuide = headerBackgroundColor === "#24221a";
	const actualHeaderColor =
		isTokioGuide && pageOrder > 0 ? "#e24217" : (headerBackgroundColor || "#e24217");
	// Borde de las cards: mismo color que la cabecera (configurable para Kioto/otros)
	const cardBorderColor = actualHeaderColor;

	const sticker1 = getImageSrc("consejos");
	const sticker2 = getImageSrc("enchufe");

	const contentColor = textColor || "#444";

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: contentColor,
		margin: "0px",
		marginBottom: "0px !important",
		"& p": {
			marginBottom: "0px !important",
		}
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
				"& p": {
					marginTop: "0px !important",
					marginBottom: "0px !important",
				},
			}}
		>
			{/* CABECERA */}
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0px",
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: "0px",
						zIndex: 99999,
					}}
				>
					{headerText}
				</Box>
			)}

			{/* INTRO */}
			{introText && (
				<Box
					data-block-id="text-1"
					sx={{
						padding: "16px",
						fontSize: "13px",
						color: contentColor,
					}}
				>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			{/* CONSEJOS */}
			<Box
				data-block-id="text-2"
				sx={{
					padding: "0px 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "12px",
					position: "relative",
					marginTop: isSmallScreen ? "30px" : "0px",
				}}
			>
				{isSmallScreen && sticker1 && !sticker1Error && (
					<Box
						component="img"
						src={sticker1}
						alt=""
						onError={() => setSticker1Error(true)}
						sx={{
							width: "89px",
							position: "absolute",
							top: "-70px",
							right: "-20px",
						}}
					/>
				)}
				{tips.map((tip, index) => (
					<Box
						key={tip.texto || index}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							border: `2px solid ${cardBorderColor}`,
						}}
					>
						{tip.icono && (
							<Box sx={{ fontSize: "18px" }}>{tip.icono}</Box>
						)}
						{tip.texto && (
							<Box sx={{ fontSize: "13px", color: contentColor }}>
								{tip.texto}
							</Box>
						)}
					</Box>
				))}

				{!isSmallScreen && sticker1 && !sticker1Error && (
					<Box
						component="img"
						src={sticker1}
						alt=""
						onError={() => setSticker1Error(true)}
						sx={{
							width: "100px",
							position: "absolute",
							top: "42px",
							right: "-9px",
						}}
					/>
				)}
				{sticker2 && !sticker2Error && (
					<Box
						component="img"
						src={sticker2}
						alt=""
						onError={() => setSticker2Error(true)}
						sx={{
							width: "100px",
							position: "absolute",
							bottom: isSmallScreen ? "-60px" : "-50px",
							right: "-30px",
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template41.thumbnail = "/images/template-1.png";

export default Template41;
